class VideoWithText2026 {
  constructor() {
    this.modal = document.querySelector('[data-video-modal]');
    this.videoContainer = document.querySelector('[data-video-container]');
    this.triggers = document.querySelectorAll('[data-video-trigger]');
    this.closeButtons = document.querySelectorAll('[data-modal-close]');

    if (!this.modal || !this.videoContainer) return;

    this.init();
  }

  init() {
    // Add click listeners to video triggers
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const isMobile = window.innerWidth < 1024;
        const videoUrl = isMobile
          ? trigger.dataset.videoMobile
          : trigger.dataset.videoDesktop;

        if (videoUrl) {
          this.openModal(videoUrl);

          // Fire custom GA4 event if the function exists
          if (typeof fireCustomGA4Event === 'function') {
            fireCustomGA4Event("start_custom_video");
          }
        }
      });
    });

    // Add click listeners to close buttons
    this.closeButtons.forEach(button => {
      button.addEventListener('click', () => this.closeModal());
    });

    // Close modal on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
        this.closeModal();
      }
    });
  }

  openModal(videoUrl) {
    const videoId = this.extractVideoID(videoUrl);

    if (!videoId) {
      console.error('Invalid video URL:', videoUrl);
      return;
    }

    // Create iframe
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    iframe.title = 'YouTube video player';
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;

    // Clear container and add iframe
    this.videoContainer.innerHTML = '';
    this.videoContainer.appendChild(iframe);

    // Show modal
    this.modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    // Hide modal
    this.modal.classList.remove('is-active');
    document.body.style.overflow = '';

    // Clear iframe after animation
    setTimeout(() => {
      this.videoContainer.innerHTML = '';
    }, 300);
  }

  extractVideoID(url) {
    // Support YouTube URLs in various formats
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new VideoWithText2026());
} else {
  new VideoWithText2026();
}
